/*eslint-disable*/ export const messages = JSON.parse("{\"textfield.label.optional\":[\"Valinnainen\"]}");
//# sourceMappingURL=messages.mjs.map